<template>
  <div class="centerBottom">
    <div class="top_area">
      <span
        class="click"
        :class="menuItem.customsQuantityRank ? 'setCursor' : ''"
        @click="showModel"
      ></span>
    </div>
    <div class="main">
      <div class="left">
        <div class="items" v-for="(item, index) in sunmList" :key="index">
          <div class="item-value">{{ item.text }}</div>
          <div class="item-number">
            {{ item.number | formatNumber }}{{ item.unit }}
          </div>
        </div>
      </div>
      <div id="centerBottom-charts"></div>
      <div class="right-list">
        <div class="title">
          报关企业排名
        </div>
        <div
          v-for="(item, index) of topCustomsWeightSummary"
          :key="index"
          class="item"
        >
          <template v-if="index <= 4">
            <div class="icon" :style="{ background: colors[index] }"></div>
            <div class="contenttext">
              <div class="name" :title="item.customerName">
                {{ item.customerName | isEmptyVal }}
              </div>
              <div class="num">
                <span>{{ item.declaredNum || 0 | formatNumber }}</span>
                <span class="unit">件</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import apiPath from '@config/api.json'
const { mapState, mapMutations } = require('vuex')
export default {
  components: {},

  data () {
    return {
      menuItem: {
        customsQuantityRank: false // 海关数量TOP排名
      },
      summary: {},
      topCustomsQuantitySummary: [],
      topCustomsWeightSummary: [],
      topSummary: {},
      colors: ['#B7BA52', '#4EC37C', '#50CFFF', '#0171FC', '#6543D6'],
      myChart: null, // 图表对象
      myChart2: null, // 图表对象
      initObj: null, // 用于定时器处理
      sunmList: [
        {
          text: '申报数量',
          number: 0,
          unit: '单'
        },
        {
          text: '结关数量',
          number: 0,
          unit: '单'
        },
        {
          text: '申报价格',
          number: 0,
          unit: 'CNY'
        },
        {
          text: '申报重量',
          number: 0,
          unit: 'kg'
        }
      ]
    }
  },

  computed: {
    ...mapState({
      homeTime: state => {
        return state.home.homeTime
      }
    })
  },

  watch: {
    homeTime: function (n) {
      this.init()
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      const setListMenu = window.JSON.parse(getListMenu)
      this.menuItem.customsQuantityRank = common.isShowItem(
        'customsQuantityRank',
        setListMenu
      )
    }
  },
  mounted () {
    this.myChart = this.$echarts.init(
      document.getElementById('centerBottom-charts')
    )
    this.init()
    this.initRank()
    // this.initDialogTotalData()
    this.initObj = setInterval(() => {
      this.init()
      this.initRank()
      // this.initDialogTotalData()
    }, 60000)
  },
  methods: {
    ...mapMutations(['setModelInfo']),
    init () {
      this.$ajax({
        method: 'post',
        url: apiPath.bigData.home.centerBottom.getDeclarationSummary,
        data: {
          // pageIndex: 1,
          // pageSize: 10,
          // yearTime: this.homeTime
        }
      }).then(res => {
        if (res && res.data) {
          let dataInfo = res.data
          this.summary = dataInfo || {}
          this.topSummary = dataInfo
          const {
            declaredNum,
            clearanceNum,
            totalPrice,
            declaredWeight
          } = dataInfo
          this.sunmList[0].number = declaredNum || 0
          this.sunmList[1].number = clearanceNum || 0
          this.sunmList[2].number = totalPrice || 0
          this.sunmList[3].number = declaredWeight || 0
        }
        this.initCharts1()
      })
    },
    initRank () {
      this.$ajax({
        method: 'post',
        url: apiPath.bigData.home.centerBottom.getDeclarationEnterpriseRank,
        data: {
          // pageIndex: 1,
          // pageSize: 10,
          // yearTime: this.homeTime
        }
      }).then(res => {
        if (res && res.data) {
          let dataInfo = res.data
          this.topCustomsWeightSummary = dataInfo || []
          // this.topCustomsWeightSummary = this.topCustomsWeightSummary.filter((e, idx) => idx <= 3)
        }
      })
    },
    initCharts1 () {
      this.myChart && this.myChart.clear()
      this.$ajax({
        method: 'post',
        url: apiPath.bigData.home.centerBottom.getDeclarationGoodsRank,
        data: {
          // pageIndex: 1,
          // pageSize: 10,
          // yearTime: this.homeTime
        }
      }).then(res => {
        if (res && res.data) {
          let topCustomsQuantitySummary = res.data
          let data = []
          for (let item of topCustomsQuantitySummary) {
            data.push({
              name: item.productName,
              value: item.declaredNum
            })
          }
          let option
          option = {
            title: {
              text: '申报商品排行占比',
              left: 'left',
              textStyle: {
                color: '#fff',
                fontSize: '14px'
              }
            },
            tooltip: {
              trigger: 'item'
            },
            series: [
              {
                // name: 'Access From',
                type: 'pie',
                radius: [40, 60],
                center: ['50%', '55%'],
                avoidLabelOverlap: true,
                // roseType: 'area',
                data: data
              }
            ]
          }
          option && this.myChart.setOption(option)
        }
      })
    },
    // initDialogTotalData () {
    //   this.$ajax({
    //     method: 'post',
    //     url: `${apiPath.bigData.home.getDeclarationEnterpriseSummary}`,
    //     data: {
    //       pageNum: 1,
    //       pageSize: 10
    //     }
    //   }).then(res => {
    //     if (res && res.data) {
    //       let dataInfo = res.data
    //       // this.topSummary = dataInfo || {}
    //     }
    //     // this.initCharts()
    //   })
    // },
    showModel () {
      if (!this.menuItem.customsQuantityRank) return
      let that = this
      this.setModelInfo({
        modelUrl: 'getDeclarationEnterpriseSummary',
        title: '报关数据统计',
        headList: [
          {
            name: '合计企业数量',
            value: that.topSummary.totalEnterpriseNum || '0',
            unit: '家'
          },
          {
            name: '申报数量',
            value: that.topSummary.declaredNum || '0',
            unit: '单'
          },
          {
            name: '结关数量',
            value: that.topSummary.clearanceNum || '0',
            unit: '单'
          },
          {
            name: '申报商品价值',
            value: that.topSummary.totalPrice || '0',
            unit: 'CNY'
          },
          {
            name: '申报商品重量',
            value: that.topSummary.declaredWeight || '0',
            unit: 'kg'
          }
        ],
        model: true,
        method: 'post'
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.initObj)
  }
}
</script>

<style lang="scss" scoped>
.right-list {
  .title {
    font-size: 14px;
    color: #ffffff;
    margin-bottom: 10px;
  }
  .item {
    display: flex;
    height: 20px;
    line-height: 20px;
    align-items: center;
    background: rgba(63, 154, 255, 0.2);
    margin-left: 6px;
    margin-right: 0;
    margin-bottom: 12px;

    .icon {
      width: 8px;
      height: 8px;
      background: #b7ba52;
      margin-left: 7px;
      border-radius: 50%;
    }

    .contenttext {
      margin-left: 17px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      font-size: 14px;

      .name {
        max-width: 90px;
        overflow: hidden;
        line-height: 24px;
        height: 24px;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 10px;
      }

      .num {
        // width: 36px;
        text-align: right;
        white-space: nowrap;

        .unit {
          font-size: 10px;
        }
      }
    }
  }
}
.centerBottom {
  width: 880px;
  height: 256px;
  background: url("~@/assets/images/home/hg-bg.png") no-repeat 0 0;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  .top_area {
    height: 60px;
    width: 100%;
    text-align: center;
    .click {
      display: inline-block;
      width: 300px;
      height: 60px;
    }
  }
  .main {
    display: flex;
    .left {
      margin-left: 30px;
      .items {
        margin-top: 10px;
        display: flex;
        font-size: 14px;
        margin-bottom: 15px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        width: 175px;
        height: 23px;
        line-height: 23px;
        border-left: 4px solid #ffffff;
        background: linear-gradient(to right, rgb(47, 92, 146), transparent);
        justify-content: space-between;
        .item-value {
          margin-left: 5px;
          text-align: right;
          max-width: 90px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .item-number {
          color: #ffffff;
        }
      }
    }
  }
  .left {
    position: relative;
    width: 180px;
    margin-right: 10px;
    .bg {
      background: url("~@/assets/images/home/fw.png") no-repeat 0 0;
      background-size: 100% 100%;
      width: 58px;
      height: 63px;
      font-size: 10px;
      line-height: 10px;
      position: absolute;
      .center {
        padding: 16px 4px;
      }
      .num {
        font-size: 15px;
        line-height: 15px;
        width: 58px;
        text-align: center;
      }
      .unit {
        font-size: 10px;
        line-height: 10px;
      }
    }
  }
  #centerBottom-charts {
    width: 380px;
    margin-right: 10px;
    height: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/home/compontents/centerBottom.vue